var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.value),function(item,index){return _c('span',{key:item._id},[_vm._v(" "+_vm._s(index > 0?_vm.separation: '')+_vm._s(item[_vm.labelField] || item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }